// extracted by mini-css-extract-plugin
module.exports = {"head":"Header-module__head___191j-","close":"Header-module__close___3qDsd","closeImg":"Header-module__closeImg___3tE4B","logo":"Header-module__logo___3thle"};